export const getLabelByPath = (labels: Record<string, any>, path: string): string | undefined => {
  if(!path) return undefined;
  const keys = path.split('.');
  let currentLabel: any = labels;

  for (const key of keys) {
    if (typeof currentLabel !== 'object' || currentLabel === null || !(key in currentLabel)) {
      return undefined;
    }
    currentLabel = currentLabel[key];
  }

  if (typeof currentLabel === 'string') {
    return currentLabel;
  }

  return undefined;
};